import { Route, Routes } from 'react-router'

import AdditionalProductsTools from './AdditionalProductsTools'
import AdditionalProductNettingPage from './AdditionalProductNettingPage'

const AdditionalSalesRouter = () => (
  <Routes>
    <Route exact path='' element={<AdditionalProductsTools />} />
    <Route path=':technicalName/netting' element={<AdditionalProductNettingPage />} />
  </Routes>
)

export default AdditionalSalesRouter
